import { useRef } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { CheckPinCodeForm } from '@/bundle/Auth/LoginFlow/CheckPinCodePage/ui/CheckPinCodeForm/CheckPinCodeForm';
import { forgotPasswordCheckPinCode } from './api';
import { useForgotPasswordNavigateToStep } from '../hooks/useForgotPasswordNavigateToStep';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';

export const ForgotPasswordCheckPinCodePage = () => {
  const checkPinCodeRef = useRef(null);
  const queryClient = useQueryClient();
  const navigateToStep = useForgotPasswordNavigateToStep();

  const {
    mutate,
    data: checkPinCodeData,
    isPending: isCheckPinCodePending,
    reset,
  } = useMutation({
    mutationKey: ['forgot_password_check_pin_code'],
    mutationFn: (pinCode: string) => {
      const payload = {
        pin: pinCode,
      };

      return forgotPasswordCheckPinCode(payload);
    },
    onSuccess(response) {
      if (response?.error) {
        queryClient.invalidateQueries({ queryKey: ['get_attempts_count'] });
        checkPinCodeRef?.current?.resetPinCode();

        return;
      }

      amplitudeService.logEvent(AMPLITUDE_EVENTS.ForgotPasswordEnterPinCode);

      return navigateToStep(response?.body);
    },
  });

  return (
    <AuthLayout>
      <CheckPinCodeForm
        ref={checkPinCodeRef}
        onConfirm={mutate}
        onReset={reset}
        isLoading={isCheckPinCodePending}
        error={checkPinCodeData?.error}
      />
    </AuthLayout>
  );
};
